import React, { useState } from 'react'
import './styles/farmloader.scss'

type FarmLoaderProps = {
  label?: string
  labelColor?: string
}

const CowBody = () => (
  <>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='158' y='88' width='12' height='34' rx='5' fill='#E7E4E0' />
      <rect x='158' y='114' width='12' height='10' rx='3' fill='#3A3A3A' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='96' y='90' width='12' height='34' rx='5' fill='#E7E4E0' />
      <rect x='96' y='116' width='12' height='10' rx='3' fill='#3A3A3A' />
    </g>

    <rect
      x='78'
      y='52'
      width='112'
      height='46'
      rx='23'
      fill='#FFFFFF'
      stroke='#E0DDD9'
      strokeWidth='2'
    />
    <ellipse cx='108' cy='62' rx='14' ry='10' fill='#EA5D0D' />
    <ellipse cx='148' cy='90' rx='10' ry='8' fill='#EA5D0D' />
    <ellipse cx='172' cy='58' rx='9' ry='7' fill='#EA5D0D' />

    <g className='farmLoader-tail'>
      <path
        d='M83,58 C 63,70 53,95 50,118'
        fill='none'
        stroke='#1A1A1A'
        strokeWidth='4'
        strokeLinecap='round'
      />
      <circle cx='50' cy='120' r='6' fill='#1A1A1A' />
    </g>

    <ellipse
      cx='200'
      cy='55'
      rx='24'
      ry='22'
      fill='#FFFFFF'
      stroke='#E0DDD9'
      strokeWidth='2'
    />
    <ellipse
      cx='188'
      cy='36'
      rx='9'
      ry='6'
      fill='#FFFFFF'
      stroke='#E0DDD9'
      strokeWidth='2'
      transform='rotate(-25 188 36)'
    />
    <ellipse cx='218' cy='62' rx='11' ry='9' fill='#F7B6A3' />
    <circle cx='213' cy='60' r='2.5' fill='#1A1A1A' />
    <circle cx='223' cy='60' r='2.5' fill='#1A1A1A' />
    <circle cx='205' cy='45' r='3' fill='#1A1A1A' />

    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='184' y='92' width='13' height='35' rx='5' fill='#F7F5F2' />
      <rect x='184' y='119' width='13' height='10' rx='3' fill='#2A2A2A' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='112' y='90' width='13' height='35' rx='5' fill='#F7F5F2' />
      <rect x='112' y='117' width='13' height='10' rx='3' fill='#2A2A2A' />
    </g>
  </>
)

const BullBody = () => (
  <>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='158' y='88' width='12' height='34' rx='5' fill='#8C7A6B' />
      <rect x='158' y='114' width='12' height='10' rx='3' fill='#2A2018' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='96' y='90' width='12' height='34' rx='5' fill='#8C7A6B' />
      <rect x='96' y='116' width='12' height='10' rx='3' fill='#2A2018' />
    </g>

    <rect
      x='78'
      y='50'
      width='114'
      height='48'
      rx='20'
      fill='#A9846A'
      stroke='#7A5C46'
      strokeWidth='2'
    />

    <g className='farmLoader-tail'>
      <path
        d='M83,58 C 63,72 53,96 50,120'
        fill='none'
        stroke='#4A3628'
        strokeWidth='4'
        strokeLinecap='round'
      />
      <circle cx='50' cy='122' r='6' fill='#2A1E15' />
    </g>

    <ellipse
      cx='202'
      cy='54'
      rx='25'
      ry='22'
      fill='#B08F72'
      stroke='#7A5C46'
      strokeWidth='2'
    />
    <path
      d='M190,36 C 184,24 178,20 172,20'
      fill='none'
      stroke='#E8E0D5'
      strokeWidth='5'
      strokeLinecap='round'
    />
    <path
      d='M214,36 C 220,24 226,20 232,20'
      fill='none'
      stroke='#E8E0D5'
      strokeWidth='5'
      strokeLinecap='round'
    />
    <ellipse cx='222' cy='64' rx='13' ry='10' fill='#4A3628' />
    <circle cx='217' cy='63' r='2' fill='#1A1208' />
    <circle cx='227' cy='63' r='2' fill='#1A1208' />
    <circle cx='196' cy='45' r='3' fill='#1A1208' />

    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='184' y='92' width='13' height='35' rx='5' fill='#9A7B60' />
      <rect x='184' y='119' width='13' height='10' rx='3' fill='#2A2018' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='112' y='90' width='13' height='35' rx='5' fill='#9A7B60' />
      <rect x='112' y='117' width='13' height='10' rx='3' fill='#2A2018' />
    </g>
  </>
)

const PigBody = () => (
  <>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='150' y='92' width='11' height='28' rx='5' fill='#F2A6C0' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='104' y='94' width='11' height='28' rx='5' fill='#F2A6C0' />
    </g>

    <rect
      x='86'
      y='58'
      width='96'
      height='40'
      rx='20'
      fill='#F7B8CE'
      stroke='#E08FAF'
      strokeWidth='2'
    />

    <g className='farmLoader-tail'>
      <path
        d='M90,64 C 76,60 72,70 80,74 C 86,77 84,66 90,64'
        fill='none'
        stroke='#E08FAF'
        strokeWidth='4'
        strokeLinecap='round'
      />
    </g>

    <path
      d='M182,44 L198,30 L192,52 Z'
      fill='#F2A6C0'
      stroke='#E08FAF'
      strokeWidth='2'
    />

    <ellipse
      cx='196'
      cy='58'
      rx='22'
      ry='20'
      fill='#F9C6DA'
      stroke='#E08FAF'
      strokeWidth='2'
    />
    <ellipse
      cx='214'
      cy='62'
      rx='10'
      ry='8'
      fill='#F2A6C0'
      stroke='#E08FAF'
      strokeWidth='2'
    />
    <ellipse cx='211' cy='62' rx='2' ry='3' fill='#B8557C' />
    <ellipse cx='218' cy='62' rx='2' ry='3' fill='#B8557C' />
    <circle cx='202' cy='48' r='3' fill='#1A1A1A' />

    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='178' y='96' width='12' height='29' rx='5' fill='#F2A6C0' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='118' y='94' width='12' height='29' rx='5' fill='#F2A6C0' />
    </g>
  </>
)

const ChickenBody = () => (
  <>
    <g className='farmLoader-leg farmLoader-leg--b'>
      <rect x='150' y='96' width='5' height='26' rx='2' fill='#E8A93A' />
    </g>
    <g className='farmLoader-leg farmLoader-leg--a'>
      <rect x='128' y='98' width='5' height='26' rx='2' fill='#E8A93A' />
    </g>

    <ellipse
      cx='140'
      cy='72'
      rx='48'
      ry='34'
      fill='#F7F3EC'
      stroke='#E0DBCF'
      strokeWidth='2'
    />
    <ellipse cx='128' cy='76' rx='20' ry='14' fill='#EDE7DA' />

    <g className='farmLoader-tail'>
      <path
        d='M96,58 C 78,48 72,36 76,26'
        fill='none'
        stroke='#DCD4C4'
        strokeWidth='8'
        strokeLinecap='round'
      />
    </g>

    <circle
      cx='182'
      cy='48'
      r='16'
      fill='#F7F3EC'
      stroke='#E0DBCF'
      strokeWidth='2'
    />
    <path
      d='M172,32 C174,24 180,22 182,30 C186,22 192,24 190,34'
      fill='#D0402A'
    />
    <path d='M196,50 L208,46 L196,42 Z' fill='#E8A93A' />
    <path d='M190,56 C192,62 188,64 186,60' fill='#D0402A' />
    <circle cx='186' cy='44' r='2' fill='#1A1A1A' />
  </>
)

const SPECIES = [CowBody, BullBody, PigBody, ChickenBody]

const FarmLoader = ({
  label = 'Carregando...',
  labelColor = '#FFFFFF',
}: FarmLoaderProps) => {
  const [speciesIndex, setSpeciesIndex] = useState(0)
  const Body = SPECIES[speciesIndex]

  const handleWalkIteration = (event: React.AnimationEvent<SVGGElement>) => {
    if (event.animationName !== 'farmLoader-walk') return
    setSpeciesIndex((current) => (current + 1) % SPECIES.length)
  }

  return (
    <div
      role='status'
      aria-live='polite'
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
      }}
    >
      <svg
        viewBox='-40 0 320 150'
        width={200}
        height={94}
        aria-hidden='true'
        focusable='false'
      >
        <g
          className='farmLoader-walker'
          onAnimationIteration={handleWalkIteration}
        >
          <ellipse
            className='farmLoader-shadow'
            cx='140'
            cy='132'
            rx='60'
            ry='8'
            fill='#000000'
          />

          <g className='farmLoader-bob'>
            <Body />
          </g>
        </g>
      </svg>

      <span
        style={{
          color: labelColor,
          fontFamily: 'Roboto, sans-serif',
          fontSize: '0.875rem',
          fontWeight: 500,
          letterSpacing: '0.02em',
          maxWidth: 280,
          textAlign: 'center',
          whiteSpace: 'pre-line',
        }}
      >
        {label}
      </span>
    </div>
  )
}

export default FarmLoader
